import type { ProductSearchProgress } from '@/entities/product';
import { SERP_PROGRESS_DRIFT_HALF_MS, SERP_PROGRESS_STAGES } from '../config/progress';
import type { SearchProgressStage } from '../model/types';

export function getJobsFill(progress: ProductSearchProgress): number {
  if (progress.jobsCount <= 0) return 0;

  return clampFill(progress.jobsSuccess / progress.jobsCount);
}

export function getSearchProgressStage(
  fill: number,
  stages: readonly SearchProgressStage[] = SERP_PROGRESS_STAGES,
): SearchProgressStage {
  return stages[getStageIndex(fill, stages.length)];
}

export function getStageEnd(fill: number, stagesCount: number = SERP_PROGRESS_STAGES.length): number {
  return (getStageIndex(fill, stagesCount) + 1) / stagesCount;
}

export function getDriftValue(from: number, to: number, elapsedMs: number): number {
  if (from >= to || elapsedMs <= 0) return from;

  return from + ((to - from) * elapsedMs) / (elapsedMs + SERP_PROGRESS_DRIFT_HALF_MS);
}

function getStageIndex(fill: number, stagesCount: number): number {
  return Math.min(Math.floor(clampFill(fill) * stagesCount), stagesCount - 1);
}

function clampFill(fill: number): number {
  if (Number.isNaN(fill) || fill < 0) return 0;

  return fill > 1 ? 1 : fill;
}
